import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
export default {
  data () {
    return {
      list: [], // 数据数组
      isadd: false,
      needPage: true, // 是否需要分页
      needQuery: true, // 是否在created就执行查询操作
      queryUrl: '', // 列表请求数据接口
      deleteUrl: '', // 删除数据url
      queryOneUrl: '', // 查询单条地址
      addOrUpdateUrl: '', // 新增或更新数据url
      addOrUpdateVisible: false, // 新增修改是否可见
      exportDataUrl: '', // 导出数据url
      exportFileName: '', // 导出文件名称
      exportLoading: false, // 导出loading
      downloadTemplateUrl: '', // 下载模板URL
      downloadTemplateName: '', // 下载模板名称
      orderColumn: '', // 排序列
      orderType: 'asc', // 正序为asc。倒序为desc
      query: {}, // 查询参数
      dataListLoading: false, // 加载中
      currentId: '', // 更新数据的id
      currentNo: '', // 更新数据的分类编码
      isUpdate: false, // 是否更新数据
      selectedRows: [], // 选中的所有数据,
      typeAorB: 'a',
      uploadHeader: {
        Authorization: storage.get(ACCESS_TOKEN),
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      addOrUpdateForm: null,
      tenantList: [], // 租户信息
    }
  },
  created () {
    if (this.needQuery) {
      this.queryList()
    }
  },
  methods: {
    moment,
    // 正则不能输入小数点
    limitNumber (value) {
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(/\./g, '') : 0
      } else {
        return 0
      }
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = 1
        this.pagination.current = 1
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 重置
    resetList () {
      console.log('zhu->resetList')
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    pageChange (pagination, filters, sorter) {
      console.log('zhu->pageChange')
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pageQueryList()
    },
    pageQueryList () {
      console.log('zhu->pageQueryList')
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.pagination.total = data.total ? parseInt(data.total) : 0
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    // 针对GIS物探点，无法与GIS返回数据关联（id与class_no），临时解决方案
    addOrUpdateHandleEdit (id, no) {
      console.log('zhu->addOrUpdateHandleEdit')
      this.isUpdate = false
      this.currentId = id
      this.currentNo = no
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.isUpdate = true
      this.$http
        .get(`${this.queryOneUrl}/${this.currentNo}`)
        .then(({ data }) => {
          this.currentId = data.id
          this.addOrUpdateForm.setFieldsValue(data)
        })
        .catch(() => { })
    },
    // 新增数据
    addOrUpdateHandle (id) {
      this.isUpdate = false
      this.isEditMode = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            console.log(data)
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => { })
      }
    },
    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          // 处理所有字段，去除前后空格
          Object.keys(values).forEach(key => {
            if (typeof values[key] === 'string') {
              values[key] = values[key].trim()
            }
          })
          this.$http[!this.currentId ? 'post' : 'put'](
            this.addOrUpdateUrl,
            this.query.sysType
              ? {
                id: this.currentId,
                sysType: this.query.sysType,
                ...values,
              }
              : {
                id: this.currentId,
                ...values,
              }
          )
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    handleCancel () {
      this.addOrUpdateForm.resetFields()
    },
    onSelectChange (selectedRowKeys) {
      this.selectedRows = selectedRowKeys
    },
    deleteSelectRow () {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      console.log(_this.selectedRows)
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http
            .delete(_this.deleteUrl, {
              data: _this.selectedRows,
            })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.resetList()
                _this.queryList()
              }
            })
            .catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    },
    // 导出
    exportHandle () {
      this.exportLoading = true
      const params = {
        responseType: 'arraybuffer',
        params: this.query,
        headers: this.uploadHeader,
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // id导出
    exportHandleIdList () {
      this.exportLoading = true
      console.log('selectedRows', this.selectedRows)
      this.query.idList = this.selectedRows

      const tenantId = storage.get('tenantId')
      const head = this.uploadHeader.Authorization
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      const instance = axios.create({
        // 设置基本的请求配置，如基本URL、请求超时时间等
        baseURL: url,
      })
      instance.defaults.responseType = 'arraybuffer'
      instance
        .post(url, this.query, {
          headers: {
            responseType: 'arraybuffer',
            Authorization: head,
            'tenantId': tenantId
          },
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // 导出
    downloadTemplate (queryParms) {
      const params = {
        params: queryParms,
        responseType: 'arraybuffer',
        headers: this.uploadHeader,
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.downloadTemplateUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const fileName = this.downloadTemplateName || '导入模板.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
        })
        .catch(() => { })
    },
    // 导出
    downloadTemplateAsset () {
      console.log(this.typeAorB)
      const params = {
        responseType: 'arraybuffer',
      }

      const head = this.uploadHeader.Authorization
      let url = `${process.env.VUE_APP_API_BASE_URL}/pipe-network/gis/pipe-networks/exportGisPipeline`
      let fileName = '管径.xlsx'

      if (this.typeAorB == 'a') {
      } else {
        url = `${process.env.VUE_APP_API_BASE_URL}/pipe-network/gis/pipe-networks/exportGisPipelineMaterialVos`
        fileName = '管材.xlsx'
      }

      const tenantId = storage.get('tenantId')
      // 创建一个axios实例
      const instance = axios.create({
        // 设置基本的请求配置，如基本URL、请求超时时间等
        baseURL: url,
      })
      instance.defaults.responseType = 'arraybuffer'
      instance
        .post(url, params, {
          headers: {
            responseType: 'arraybuffer',
            Authorization: head,
            'tenantId': tenantId
          },
        })
        .then((res) => {
          console.log(res)
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })

          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    getAllTenant () {
      if (this.$store.state.user.info.systemAdmin) {
        this.$http
          .get('/manager/tenants/all')
          .then(({ data }) => {
            this.tenantList = data
          })
          .catch(({ e }) => {
            console.log(e)
          })
      }
    },
    /**
 * 通用二进制文件下载方法（支持 DXF/XLSX 等）
 * @param {String} url - 完整API地址
 * @param {Object} config - 请求配置
 * @param {String} defaultFilename - 默认文件名
 */
    downloadBinaryFile (url, config = {}, defaultFilename = 'file.dxf') {
      const {
        responseType = 'arraybuffer',
        headers = {},
        params = {},
        ...restConfig
      } = config;

      // 合并请求头（保留授权信息）
      const finalHeaders = {
        ...this.uploadHeader,
        Accept: 'application/octet-stream',
        ...headers
      };
      const urls = `${process.env.VUE_APP_API_BASE_URL}${url}`
      return axios.get(urls, {
        responseType,
        headers: finalHeaders,
        params,
        ...restConfig
      }).then(response => {
        // 1. 验证数据
        if (!response.data || response.data.byteLength === 0) {
          throw new Error('空文件响应');
        }

        // 2. 解析文件名（优先级：Content-Disposition > 传入的默认值）
        let filename = defaultFilename;
        const disposition = response.headers['content-disposition'];

        if (disposition) {
          // 处理所有可能的文件名格式
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
          const stdMatch = disposition.match(/filename="?([^"]+)"?/i);

          if (utf8Match) {
            filename = decodeURIComponent(utf8Match[1]);
          } else if (stdMatch) {
            filename = stdMatch[1].replace(/^"+|"+$/g, '');
          }
        }

        // 3. 创建 Blob（自动识别MIME类型）
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/octet-stream'
        });

        // 4. 触发下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 5. 清理资源
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        }, 200);

        return filename;
      });
    },

  },
}
